import { Link } from "react-router-dom";
import SiteNavbar from "@/components/feature/SiteNavbar";
import SiteFooter from "@/components/feature/SiteFooter";

export default function NotFound() {
  return (
    <div className="min-h-screen bg-background-50 flex flex-col">
      <SiteNavbar />
      <main className="flex-1 flex flex-col items-center justify-center px-4 pt-16 text-center">
        <p className="font-heading text-6xl md:text-8xl font-bold text-primary-500 mb-4">404</p>
        <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
          页面走丢了
        </h1>
        <p className="text-sm text-foreground-500 mb-8 max-w-md">
          你访问的页面不存在，可能已被移动或删除。不如回到首页，继续欣赏女性摄影大片。
        </p>
        <div className="flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/"
            className="px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            返回首页
          </Link>
          <Link
            to="/inspiration"
            className="px-6 py-3 rounded-md border border-background-300 text-sm text-foreground-700 hover:border-primary-400 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            浏览灵感专题
          </Link>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}